export default __webpack_public_path__ + "static/media/performance-security-icon.9a42a7ec.svg";